export const INVOICE_OPTIONS = {
  invoiceKey: 'invoice_key',
  invoiceNumber: 'invoice_number',
};
